import { render, staticRenderFns } from "./allRequests.vue?vue&type=template&id=764208ea&"
import script from "./allRequests.vue?vue&type=script&lang=js&"
export * from "./allRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Volumes/Work/Work/gerocare/CrmWeb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports